export const numberToMinutes = (number: number): string => {
  const seconds_denamenator = number > 1 ? Math.trunc(number) : 1;
  const minutes = Math.trunc(number);
  const _seconds = Math.trunc(60 * (number % seconds_denamenator));
  const seconds = _seconds > 9 ? _seconds : `0${_seconds}`;
  return `${minutes}:${seconds}`;
};
